<div class="container" [ngClass]="{ readonly: ReadOnly == true }">
    <div class="row container-fluid info-search" style="padding-top:0.3rem;">
        <div class="row providerinfo">Provider Information</div>
        <div class="row providerinfomsg">Please select one of the required fields below</div>
        <div class="search-field-container">
          <form>
            <div class="row">
                <div class="col-3">
                    <label class="search-field-label">Provider NPI</label>
                    <input type="text" name="providernpi" class="search-field" [(ngModel)]="providerSearchData.Npi">
                </div>
                <div class="col-3">
                    <label class="search-field-label">Fed ID</label>
                    <input type="text" name="fedid" class="search-field" [(ngModel)]="providerSearchData.FedId"/>
                </div>
                <div class="col-3">
                    <label class="search-field-label">Full Name</label>
                    <input type="text" name="fullname" class="search-field" [(ngModel)]="providerSearchData.FullName">
                </div>
                <div class="col-3">
                    <label class="search-field-label">State</label>
                    <input type="text" name="state" class="search-field" [(ngModel)]="providerSearchData.State"/>
                </div>
            </div>
            <div class="row">
                <div class="col-3">
                    <label class="search-field-label">Gender (Female or Male)</label>
                    <input type="text" name="gender" class="search-field" [(ngModel)]="providerSearchData.Gender">
                </div>
                <div class="col-3">
                    <label class="search-field-label">Provider Type</label>
                    <input type="text" name="providertype" class="search-field" [(ngModel)]="providerSearchData.ProviderType"/>
                </div>
                <div class="col-3">
                    <label class="search-field-label">Specialty Code</label>
                    <input type="text" name="specialtycode" class="search-field" [(ngModel)]="providerSearchData.SpecialtyCode">
                </div>
                <div class="col-3">
                    <label class="search-field-label">City</label>
                    <input type="text" name="city" class="search-field" [(ngModel)]="providerSearchData.City"/>
                </div>
                
            </div>
            <div class="row">
                <div class="col-3">
                    <label class="search-field-label">Country</label>
                    <input type="text" name="country" class="search-field" [(ngModel)]="providerSearchData.County">
                </div>
                <div class="col"></div>
            </div>
            <div class="row" style="padding-top:0.2rem;">
                <div class="col-1 col-serach">
                    <!-- <button class="btn-search" (click)="search()">Search</button> -->
                    <input class="btn-search" type="submit" value="Search" (click)="search()">
                </div>
                <div class="col">
                    <button class="clear-search" (click)="clearSearchResults()">Clear Search Results</button>
                </div>
            </div>
          </form>
        </div>
    </div>
    <div class="row container-fluid provider-information" *ngIf="showTabularData">
      <hr class="light-separator" />
      <label class="recordcount">{{ProviderData?ProviderData.length:0}} Records Found</label>
      <p-table [value]="ProviderData" [tableStyle]="{ 'min-width': '50rem' }"
      [(first)]="currentpage"
      [paginator]="true"
      [rows]="5"
      [totalRecords]="ProviderData?.length"
      (onRowSelect)="onRowSelect($event)"
      selectionMode="single"
      [scrollable]="true"
      (onPage)="onPageChange($event)"
      >
          <ng-template pTemplate="header">
              <tr>
                  <th>Provider NPI</th>
                  <th>Fed ID</th>
                  <th>Provider ID</th>
                  <th>Provider Type</th>
                  <th>Speciality Code</th>
                  <th>Sex</th>
                  <th>Full Name
                    <span class="sort" (click)="sortByName()">
                      <ng-container *ngIf="sortOrder; else others">
                        <ng-container *ngIf="sortOrder=='Asc'; else falseBlock">
                          <img alt="" class="sort-btn" src="{{ baseHref }}/assets/images/icon-sort-up.png" />
                        </ng-container>
                        <ng-template #falseBlock>
                          <img alt="" class="sort-btn" src="{{ baseHref }}/assets/images/icon-sort-down.png" />
                        </ng-template>
                      </ng-container>
    
                      <ng-template #others>
                        <img alt="" class="sort-btn" src="{{ baseHref }}/assets/images/icon-sort.png" />
                      </ng-template>
                    </span>
                  </th>
                  <th>Address</th>
                  <th>Country</th>
              </tr>
          </ng-template>
          <ng-template pTemplate="body" let-providerInfo>
              <tr [pSelectableRow]="providerInfo">
                  <td> {{providerInfo['Npi']}}</td>
                  <td>{{providerInfo['FedId']}} </td>
                  <td>{{providerInfo['ProvId']}} </td>
                  <td>{{providerInfo['ProviderType']}} </td>
                  <td>{{providerInfo['SpecialityCode']}} </td>
                  <td>{{providerInfo['Sex']}} </td>
                  <td>{{providerInfo['FullName']}} </td>
                  <td>{{getAddress(providerInfo['address'])}} </td>
                  <td>{{providerInfo['address']['county']}} </td>
              </tr>
          </ng-template>
      </p-table>

    </div>
    <div class="row container-fluid provider-information" *ngIf="displayProviderInfo">
      <hr class="light-separator" />
      <a (click)="navBack()" class="navCont navback" *ngIf="ProviderData?.length>1"><pre class="navback arrow" >< </pre>Back</a>
      <label class="lbl-provider">{{ProviderName?ProviderName:''}}</label>
      <hr class="separator" />
      <!-- <form [formGroup]="dynamicForm" *ngIf="FieldsConf.Groups.length > 0"> -->
       <div class="data-container">
          <div class="input-data" *ngFor="let kv of mappedDetails | keyvalue">
              <label class="info-label" for="{{ kv.key }}">{{ kv.key }}</label><br />
              <label class="info-value" for="{{ kv.value }}">{{ kv.value || '-'}}</label><br />
          </div> 
        </div>
      <!-- </form> -->
    </div>
  </div>